/**
 * @generated SignedSource<<94e6f9df5d900fb6e36a3da8dc2a4a2d>>
 * @relayHash 9710a8e78e25f0ad7f1915ebcb8856f8
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9710a8e78e25f0ad7f1915ebcb8856f8

import type { ConcreteRequest } from 'relay-runtime';
export type UnpinIssueCommentInput = {
  clientMutationId?: string | null | undefined;
  issueCommentId: string;
};
export type unpinCommentMutation$variables = {
  input: UnpinIssueCommentInput;
};
export type unpinCommentMutation$data = {
  readonly unpinIssueComment: {
    readonly clientMutationId: string | null | undefined;
    readonly issueComment: {
      readonly id: string;
      readonly isPinned: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type unpinCommentMutation$rawResponse = {
  readonly unpinIssueComment: {
    readonly clientMutationId: string | null | undefined;
    readonly issueComment: {
      readonly id: string;
      readonly isPinned: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type unpinCommentMutation = {
  rawResponse: unpinCommentMutation$rawResponse;
  response: unpinCommentMutation$data;
  variables: unpinCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UnpinIssueCommentPayload",
    "kind": "LinkedField",
    "name": "unpinIssueComment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IssueComment",
        "kind": "LinkedField",
        "name": "issueComment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPinned",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "unpinCommentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "unpinCommentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "9710a8e78e25f0ad7f1915ebcb8856f8",
    "metadata": {},
    "name": "unpinCommentMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "1a59136c3365b4350e72719aa0ad14c2";

export default node;
